import React, { useState, useEffect } from 'react';
import { useNavigate } from '@plasma/ui.application.router';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { CalculatedConsumablesDemandProps } from './calculated-consumables-demand';
import help from './calculated-consumables-demand.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import allRfqMasterColumns from '../../types/allRfqMasterDatatype';
import calculatedConsDemandColumns from '../../types/calculatedConsDemandDataType';

import {useParams} from '@plasma/ui.application.router';
import { apiUriConsumableDataHttp } from '../../services/conf/apiConf';

function useCalculatedConsumablesDemandHook(props: CalculatedConsumablesDemandProps) {
  useResourceBundle(translations, undefined, '52894202-47a5-47de-a820-2036c83822b4');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([]);
  const [dataForCart, setdataForCart] = useState([]);
  const [columnNames, setcolumnNames] = useState(calculatedConsDemandColumns());
  const [dataForRFQ, setdataForRFQ] = useState([]);

  const navigate = useNavigate();
  const {planId} = useParams();
  //console.log("consumable demand screen "+planId);

  useEffect(()=> {
    fetchAllDataGet_byApiName(`GetConsumableDemand?PlanId=${planId}`, apiUriConsumableDataHttp())
    .then((data) => {
      setdataForColumns(data.demandSummary);
      setdataForCart(data.demandDetails);
    })
    .catch((error) => {
      console.log('failed to fetch');
    });
  },[]);

  const handleRowSelection = () => {

  };

  const handleSaveAndDeleteFromTable = () => {

  };

  const handleAddToCart = () => {
    sendAllDataPost_byApiNameAndData('CreateConsumableDemandDetails', dataForCart, apiUriConsumableDataHttp())
    .then((data) => {
      //console.log('response data', data);
      if(data){
        navigate('/shopping-cart');
      }
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const handleAdjustProdMix = () => {
    navigate('/production-figure');
  };

  return {
    t,
    columnNames,
    dataForColumns,
    handleRowSelection,
    handleSaveAndDeleteFromTable,
    handleAddToCart,
    handleAdjustProdMix
  };
}

export default useCalculatedConsumablesDemandHook;
